import OverviewWrapper from './OverviewWrapper';

export default OverviewWrapper;
